import PrintProductSizeRoesConfiguratorModal, {
  PRINT_PRODUCT_SIZE_ROES_CONFIGURATOR_MODAL,
} from './modal';

export { PRINT_PRODUCT_SIZE_ROES_CONFIGURATOR_MODAL };

export default PrintProductSizeRoesConfiguratorModal;
